import * as React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import {
  BakeasyButtonClose,
  BakeasyButtonProceed,
} from '../../components/buttons/BakeasyButton';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../redux_store/reduxStore';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { editOrderTableHeaders } from '../../constants/TableHeaders';
import { Close } from '@mui/icons-material';
import { t } from 'i18next';
import {
  clearOrdersState,
  proceedOrder,
} from '../../redux_store/slices/ordersSlice';
import {
  isParsableToFloat,
  removePercentageFromTax,
} from '../../utils/ValidationUtils';

export const EditOrder = (props: any) => {
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);
  const navigate = useNavigate();

  const [ordersList, setOrdersList] = useState<any[]>(
    state?.selectedOrders?.length ? state.selectedOrders : []
  );

  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [quantity, setQuantity] = React.useState<any>([]);

  useEffect(() => {
    if (props?.params?.data) {
      setData(props?.params?.data);
    }
  }, [props?.isEdit?.params?.data]);

  function handleClose() {
    myContext.setDialog({ open: false });
  }
  debugger;
  function setData(data: any) {
    if (data?.products?.length > 0) {
      const orders = data?.products?.map((item: any) => {
        item.unitPrice = item?.price;
        item.quantity = item?.quantity;
        item.confirmedQuantity = item.confirmedQuantity ?? item?.quantity;
        item.price = item?.price;
        item.totalPrice = item?.totalPrice;
        item.backOrderChecked = false;
        item.processOrderChecked = false;
        item.cancelOrderChecked = false;
        return item;
      });

      setOrdersList(orders);
    }
  }

  const handleRowCheck = (row: any, checked: boolean) => {
    let updatedSelectedRows = [];

    if (checked) {
      const existingIndex = selectedRows.findIndex(
        (item: any) => item._id === row._id
      );
      if (existingIndex !== -1) {
        updatedSelectedRows = [...selectedRows];
        updatedSelectedRows[existingIndex] = {
          ...updatedSelectedRows[existingIndex],
          ...row,
        };
      } else {
        updatedSelectedRows = [...selectedRows, row];
      }
    } else {
      updatedSelectedRows = selectedRows.filter(
        (tableRow: any) => tableRow._id !== row._id
      );
    }

    setSelectedRows(updatedSelectedRows);
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      const updatedOrdersList = ordersList.map((order) => {
        const selectedRow = selectedRows.find(
          (row: any) => row._id === order._id
        );
        if (selectedRow) {
          return { ...order, ...selectedRow };
        }
        return order;
      });

      setOrdersList(updatedOrdersList);
    }
  }, [selectedRows]);

  function handleCheckQuantityChange(row: any) {
    let filteredRowIndex1 = ordersList.findIndex(
      (tableRow: any) => tableRow.productId === row?.productId
    );
    if (filteredRowIndex1 >= 0) {
      let a = ordersList;
      a[filteredRowIndex1] = row;
      // setOrdersList([...a]);
      setSelectedRows([...a]);
    }
  }
  const handleQuantityChange = (row: any, value: any) => {
    handleCheckQuantityChange(row);
  };

  const calculateTotalPrice = (products: any) => {
    let subTotal1: number = products?.reduce((total: number, order: any) => {
      let tempTotalPrice =
        total +
        parseFloat(
          (
            parseFloat(order?.confirmedQuantity ?? order?.quantity) *
            parseFloat(order?.price)
          ).toFixed(2)
        );

      return tempTotalPrice;
    }, 0);

    subTotal1 = parseFloat(subTotal1.toFixed(2));
    let calculatedsubTotal = subTotal1;

    const getTaxRate = (taxRate: string | undefined) => {
      if (!taxRate || taxRate === 'Not Applicable') return 0;
      const cleanedTaxRate = removePercentageFromTax(taxRate);
      return isParsableToFloat(cleanedTaxRate) ? parseFloat(cleanedTaxRate) : 0;
    };

    const taxRate1 = getTaxRate(props?.params?.selectedTaxRate1?.taxName);
    const taxRate2 = getTaxRate(props?.params?.selectedTaxRate2?.taxName);

    if (isNaN(subTotal1)) subTotal1 = 0;
    const safeTaxRate1 = isNaN(taxRate1) ? 0 : taxRate1;
    const safeTaxRate2 = isNaN(taxRate2) ? 0 : taxRate2;

    const calculatedtax1: number = parseFloat(
      ((safeTaxRate1 / 100) * subTotal1).toFixed(2)
    );
    const calculatedtax2: number = parseFloat(
      ((safeTaxRate2 / 100) * subTotal1).toFixed(2)
    );

    const shippingEnabled = props?.params?.data?.selectedValue?.shippingCharges;

    const shippingRate = props?.params?.data?.selectedValue?.shippingRate;

    const shippingRateType =
      props?.params?.data?.selectedValue?.shippingRateType;

    let calculatedshippingCharge = 0;

    if (shippingEnabled) {
      if (shippingRateType === 'Percentage') {
        calculatedshippingCharge = parseFloat(
          ((subTotal1 * Number(shippingRate || 0)) / 100).toFixed(2)
        );
      } else if (shippingRateType === 'Amount') {
        calculatedshippingCharge = Number(shippingRate || 0);
      }
    }
    const calculatedtotal = parseFloat(
      (
        subTotal1 +
        calculatedtax1 +
        calculatedtax2 +
        calculatedshippingCharge
      ).toFixed(2)
    );
    return {
      calculatedsubTotal,
      calculatedtax1,
      calculatedtax2,
      calculatedshippingCharge,
      calculatedtotal,
    };
  };

  const handleProceedClick = async () => {
    if (selectedRows.length === 0) {
      dispatch(
        showErrorSnackbar({ message: t('NO_PRODUCTS_SELECTED_ASSIGNMENT') })
      );
      return;
    }

    if (selectedRows.length < ordersList.length) {
      dispatch(showErrorSnackbar({ message: t('SELECT_ALL_ROWS_ASSIGNMENT') }));
      return;
    }

    let indexOfZeroQuantity: number = selectedRows?.findIndex(
      (item?: any) =>
        item?.confirmedQuantity === '0' || item?.confirmedQuantity === 0
    );

    if (indexOfZeroQuantity >= 0) {
      dispatch(showErrorSnackbar({ message: t('ZERO_QUANTITY_NOT_ALLOWED') }));
      return;
    }

    const products = selectedRows.map((row: any) => {
      return {
        price: row.price,
        quantity: row?.quantity,
        confirmedQuantity: row.confirmedQuantity ?? row?.quantity,
        productId: row.productId,
        ...(row.processOrderChecked && { status: 'Processed' }),
        ...(row.backOrderChecked && { status: 'Backorder' }),
        ...(row.cancelOrderChecked && { status: 'Cancelled' }),
      };
    });

    // const groupedProducts = products.reduce((acc: any, item: any) => {
    //   if (!acc[item.status]) {
    //     acc[item.status] = [];
    //   }
    //   acc[item.status].push(item);
    //   return acc;
    // }, {});

    const groupedProducts = products.reduce((acc: any, item: any) => {
      if (!item.status) return acc;

      if (!acc[item.status]) {
        acc[item.status] = [];
      }

      acc[item.status].push(item);
      return acc;
    }, {});

    //await dispatch(proceedOrder({ id: props?.params?._id, products }));
    let backorderCalculation: any = {};
    if (groupedProducts['Backorder']?.length > 0) {
      backorderCalculation = calculateTotalPrice(groupedProducts['Backorder']);
    }
    // let processesOrderCalculation: any = calculateTotalPrice(groupedProducts['Processed']);
    let processesOrderCalculation: any = {};
    if (groupedProducts['Processed']?.length > 0) {
      processesOrderCalculation = calculateTotalPrice(
        groupedProducts['Processed']
      );
    }

    await dispatch(
      proceedOrder({
        id: props?.params?._id,
        groupedProducts,
        backorderCalculation,
        processesOrderCalculation,
      })
    );

    handleClose();
    navigate(-1);
    dispatch(clearOrdersState());
  };

  return (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('EDIT_ORDER')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent dividers>
        <Grid>
          <Grid>
            {ordersList?.length > 0 && (
              <BakeasySimpleTable
                headers={editOrderTableHeaders}
                tableData={ordersList}
                handleCheckChanged={handleRowCheck}
                handleQuantityChanged={handleQuantityChange}
              />
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ margin: 1 }}>
        <BakeasyButtonClose onClick={handleClose} />
        <BakeasyButtonProceed onClick={handleProceedClick} />
      </DialogActions>
    </>
  );
};
